export const steps = ["Patient Details", "Image Upload", "Review Details"];